import { LoanReconciliationInputs } from './LoanReconciliationInputs';

export default LoanReconciliationInputs;
